export enum AuthFlowType {
  RECOVER_PASSWORD_PHONE = 'recover-password-phone',
  RECOVER_PASSWORD_PHONE_OTP_TO_EMAIL = 'recover-password-phone-otp-to-email',
  RECOVER_PASSWORD_EMAIL = 'recover-password-email',
  EMAIL_MFA = 'email-mfa',
  PHONE_MFA = 'phone-mfa',
  PHONE = 'phone',
  EMAIL = 'email',
  PHONE_ASSOCIATION = 'phone-association',
  EMAIL_ASSOCIATION = 'email-association',
  SC_RECOVER_PASSWORD_PHONE = 'sc-recover-password-phone',
  SC_RECOVER_PASSWORD_EMAIL = 'sc-recover-password-email',
  PHONE_FRESH_START = 'phone-fresh-start',
  // PHONE_REGISTRATION_EMAIL_ASSOCIATION = 'phone-registration-email-association',
  // EMAIL_REGISTRATION_PHONE_ASSOCIATION = 'email-registration-phone-association',
  // EMAIL_LOGIN_PHONE_NUMBER = 'email-login-phone-number',
}

export enum FlowType {
  AUTH = 'auth',
  ASSOCIATION = 'association'
}

export enum AuthStepType {
  VALIDATE_PASSWORD = 'validate-password',
  SET_PASSWORD = 'set-password',
  VERIFY_OTP = 'verify-otp',
  RECOVER_PIN = 'recover-pin',
  PHONE_ASSOCIATION = 'phone-association',
  EMAIL_ASSOCIATION = 'email-association',
  MFA_VALIDATION = 'mfa-validation'
}

export type OtpChannel = 'email' | 'sms';
export type ResendStrategy = 'mfa' | 'otp' | 'passwordRecover' | 'scPasswordRecover';

export interface FlowConfig {
  form: string;
  flow: AuthFlowType;
  type: FlowType,
  labels: {
    headerTitle: string;
    headerSubtitle?: string;
    nextButton: string;
    skipButton?: string;
  }
  identifierField: 'email' | 'phoneNumber' | 'identifier';
  otpChannel: OtpChannel;
  resendStrategy: ResendStrategy;
  previousStepBackXTimes: number;
}

export const FLOW_CONFIGS: Record<AuthFlowType, FlowConfig> = {
  [AuthFlowType.RECOVER_PASSWORD_PHONE]: {
    form: "verify_otp__" + AuthFlowType.RECOVER_PASSWORD_PHONE,
    flow: AuthFlowType.RECOVER_PASSWORD_PHONE,
    type: FlowType.AUTH,
    labels: {
      headerTitle: "password_recover.header_otp_title",
      headerSubtitle: "password_recover.header_otp_message",
      nextButton: 'password_recover.button_next_message'
    },
    identifierField: 'identifier',
    otpChannel: 'sms',
    resendStrategy: 'passwordRecover',
    previousStepBackXTimes: 1
  },
  [AuthFlowType.RECOVER_PASSWORD_PHONE_OTP_TO_EMAIL]: {
    form: "verify_otp__" + AuthFlowType.RECOVER_PASSWORD_PHONE,
    flow: AuthFlowType.RECOVER_PASSWORD_PHONE,
    type: FlowType.AUTH,
    labels: {
      headerTitle: "password_recover.header_otp_title",
      headerSubtitle: "password_recover.header_otp_message",
      nextButton: 'password_recover.button_next_message'
    },
    identifierField: 'identifier',
    otpChannel: 'email',
    resendStrategy: 'passwordRecover',
    previousStepBackXTimes: 2
  },
  [AuthFlowType.RECOVER_PASSWORD_EMAIL]: {
    form: "verify_otp__" + AuthFlowType.RECOVER_PASSWORD_EMAIL,
    flow: AuthFlowType.RECOVER_PASSWORD_EMAIL,
    type: FlowType.AUTH,
    labels: {
      headerTitle: "password_recover.header_otp_title",
      headerSubtitle: "password_recover.header_otp_message",
      nextButton: 'password_recover.button_next_message'
    },
    identifierField: 'identifier',
    otpChannel: 'email',
    resendStrategy: 'passwordRecover',
    previousStepBackXTimes: 1
  },
  [AuthFlowType.EMAIL_MFA]: {
    form: "verify_otp__" + AuthFlowType.EMAIL_MFA,
    flow: AuthFlowType.EMAIL_MFA,
    type: FlowType.AUTH,
    labels: {
      headerTitle: "mfa_validation.header_title",
      headerSubtitle: "mfa_validation.header_message_email",
      nextButton: 'mfa_validation.button_next_message'
    },
    identifierField: 'email',
    otpChannel: 'email',
    resendStrategy: 'mfa',
    previousStepBackXTimes: 1
  },
  [AuthFlowType.PHONE_MFA]: {
    form: "verify_otp__" + AuthFlowType.PHONE_MFA,
    flow: AuthFlowType.PHONE_MFA,
    type: FlowType.AUTH,
    labels: {
      headerTitle: "mfa_validation.header_title",
      headerSubtitle: "mfa_validation.header_message_phone",
      nextButton: 'mfa_validation.button_next_message'
    },
    identifierField: 'phoneNumber',
    otpChannel: 'sms',
    resendStrategy: 'mfa',
    previousStepBackXTimes: 1
  }
  , [AuthFlowType.PHONE]: {
    form: "verify_otp__" + AuthFlowType.PHONE,
    flow: AuthFlowType.PHONE,
    type: FlowType.AUTH,
    labels: {
      headerTitle: "otp_validation.header_title_mobile",
      headerSubtitle: "otp_validation.header_message",
      nextButton: 'otp_validation.button_next_message'
    },
    identifierField: 'phoneNumber',
    otpChannel: 'sms',
    resendStrategy: 'otp',
    previousStepBackXTimes: 1
  },
  [AuthFlowType.EMAIL]: {
    form: "verify_otp__" + AuthFlowType.EMAIL,
    flow: AuthFlowType.EMAIL,
    type: FlowType.AUTH,
    labels: {
      headerTitle: "email_otp_validation.header_title",
      headerSubtitle: "email_otp_validation.header_message",
      nextButton: 'otp_validation.button_next_message'
    },
    identifierField: 'email',
    otpChannel: 'email',
    resendStrategy: 'otp',
    previousStepBackXTimes: 1
  },
  [AuthFlowType.PHONE_ASSOCIATION]: {
    form: "verify_otp__" + AuthFlowType.PHONE_ASSOCIATION,
    flow: AuthFlowType.PHONE_ASSOCIATION,
    type: FlowType.ASSOCIATION,
    labels: {
      headerTitle: "otp_validation.header_title_mobile",
      headerSubtitle: "otp_validation.header_message",
      nextButton: 'otp_validation.button_next_message',
      skipButton: 'phonenumber_association.jump_next_button_message'
    },
    identifierField: 'phoneNumber',
    otpChannel: 'sms',
    resendStrategy: 'otp',
    previousStepBackXTimes: 1
  }
  , [AuthFlowType.EMAIL_ASSOCIATION]: {
    form: "verify_otp__" + AuthFlowType.EMAIL_ASSOCIATION,
    flow: AuthFlowType.EMAIL_ASSOCIATION,
    type: FlowType.ASSOCIATION,
    labels: {
      headerTitle: "email_otp_validation.header_title",
      headerSubtitle: "email_otp_validation.header_message",
      nextButton: 'otp_validation.button_next_message',
      skipButton: 'email_association.jump_next_button_message'
    },
    identifierField: 'email',
    otpChannel: 'email',
    resendStrategy: 'otp',
    previousStepBackXTimes: 1
  },
  [AuthFlowType.SC_RECOVER_PASSWORD_PHONE]: {
    form: "verify_otp__" + AuthFlowType.SC_RECOVER_PASSWORD_PHONE,
    flow: AuthFlowType.SC_RECOVER_PASSWORD_PHONE,
    type: FlowType.AUTH,
    labels: {
      headerTitle: "site_credentials.password_recover.header_otp_title",
      headerSubtitle: "site_credentials.password_recover.header_otp_message",
      nextButton: 'password_recover.button_next_message'
    },
    identifierField: 'identifier',
    otpChannel: 'sms',
    resendStrategy: 'scPasswordRecover',
    previousStepBackXTimes: 1
  },
  [AuthFlowType.SC_RECOVER_PASSWORD_EMAIL]: {
    form: "verify_otp__" + AuthFlowType.SC_RECOVER_PASSWORD_EMAIL,
    flow: AuthFlowType.SC_RECOVER_PASSWORD_EMAIL,
    type: FlowType.AUTH,
    labels: {
      headerTitle: "site_credentials.password_recover.header_otp_title",
      headerSubtitle: "site_credentials.password_recover.header_otp_email_message",
      nextButton: 'password_recover.button_next_message'
    },
    identifierField: 'identifier',
    otpChannel: 'email',
    resendStrategy: 'scPasswordRecover',
    previousStepBackXTimes: 1
  },
  [AuthFlowType.PHONE_FRESH_START]: {
    form: "verify_otp__" + AuthFlowType.PHONE_FRESH_START,
    flow: AuthFlowType.PHONE_FRESH_START,
    type: FlowType.AUTH,
    labels: {
      headerTitle: "otp_validation.header_title_mobile",
      headerSubtitle: "otp_validation.header_message",
      nextButton: 'otp_validation.button_next_message'
    },
    identifierField: 'phoneNumber',
    otpChannel: 'sms',
    resendStrategy: 'otp',
    previousStepBackXTimes: 1
  },
};
